import * as React from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { baseColors, RelodeTheme } from "../styles";
import { CheckIcon, domain, TimesIcon } from "../..";
import classnames from "classnames";

const useMetStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                border: "2px solid transparent",
                borderRadius: 50,
                width: 32,
                height: 32,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: 16,
            },
            met: {
                backgroundColor: baseColors.green,
                color: baseColors.navy,
                stroke: baseColors.navy,
                strokeWidth: "8%",
            },
            notMet: {
                backgroundColor: baseColors.danger_red,
                color: baseColors.white,
                stroke: baseColors.white,
                strokeWidth: "8%",
            },
            notAnswered: {
                borderColor: baseColors.gray,
            },
        }),
    { name: "QualificationMetOrNot" }
);

export const QualificationMetOrNot = (props: {
    requirement: domain.JobQualificationRequirement;
}) => {
    const classes = useMetStyles({});
    const render = () => {
        switch (props.requirement) {
            case domain.JobQualificationRequirement.Met: {
                return <CheckIcon fontSize="small" />;
            }
            case domain.JobQualificationRequirement.NotMet: {
                return <TimesIcon fontSize="small" />;
            }
            case domain.JobQualificationRequirement.NotAnswered: {
                return <span />;
            }
        }
    };

    return (
        <div
            className={classnames(classes.root, {
                [classes[props.requirement.description]]: true,
            })}
        >
            {render()}
        </div>
    );
};
